import React, { useState } from 'react';
import Home from './pages/Home';
import LoginPage from './pages/LoginPage';
import CadastroPage from './pages/CadastroPage';
import PerfilPage from './pages/PerfilPage';
import PerfilAgricultorPage from './pages/PerfilAgricultorPage';
import EditarCadastroPage from './pages/EditarCadastroPage';
import BuscarAgricultoresPage from './pages/BuscarAgricultoresPage';
import ProdutosAgricultorPage from './pages/ProdutosAgricultorPage';

const App = () => {
    const [currentPage, setCurrentPage] = useState('Home'); 
    const [userName, setUserName] = useState(localStorage.getItem('userName') || ''); 
    const [restauranteId, setRestauranteId] = useState(localStorage.getItem('restauranteId'));
    const [agricultorId, setAgricultorId] = useState(localStorage.getItem('agricultorId'));
    const [userType, setUserType] = useState(localStorage.getItem('userType')); 

    const isLoggedIn = restauranteId || agricultorId; 

    const handleLoginSuccess = (page, name, id, role) => { 
        if (name) localStorage.setItem('userName', name);
        if (role) localStorage.setItem('userType', role);
        
        // Atualizar estados baseado no role
        if (role === 'RESTAURANTE') {
            localStorage.setItem('restauranteId', id);
            setRestauranteId(id);
            setAgricultorId(null);
        } else if (role === 'AGRICULTOR') {
            localStorage.setItem('agricultorId', id);
            setAgricultorId(id);
            setRestauranteId(null);
        }
        
        setUserType(role);
        setUserName(name);
        setCurrentPage(role === 'RESTAURANTE' ? 'Estoque' : 'ProdutosAgricultor');
    };

    const handleLogout = () => {
        localStorage.removeItem('restauranteId');
        localStorage.removeItem('agricultorId');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userName');
        localStorage.removeItem('userType');
        setRestauranteId(null);
        setAgricultorId(null);
        setUserType(null); 
        setUserName('');
        setCurrentPage('Home');
    };

    const handleNavigateSimple = (page, name = '') => {
        setUserName(name);
        setCurrentPage(page);
    };

    const renderPage = () => {
        switch (currentPage) {
            case 'Login':
                return <LoginPage onNavigate={handleLoginSuccess} />; 
            case 'Cadastro':
                return <CadastroPage onNavigate={handleNavigateSimple} />;
            case 'Perfil':
                if (userType === 'AGRICULTOR') {
                    return <PerfilAgricultorPage 
                                onNavigate={handleNavigateSimple} 
                                nomeUsuario={userName}
                            />;
                }
                return <PerfilPage 
                            onNavigate={handleNavigateSimple} 
                            nomeUsuario={userName} 
                            handleLogout={handleLogout}
                            restauranteId={restauranteId}
                            abaMostrar="perfil"
                        />;
            case 'Estoque':
                return <PerfilPage 
                            onNavigate={handleNavigateSimple} 
                            nomeUsuario={userName} 
                            handleLogout={handleLogout}
                            restauranteId={restauranteId}
                            abaMostrar="estoque"
                        />;
            case 'EditarCadastro':
                return <EditarCadastroPage 
                            onNavigate={handleLoginSuccess}
                            restauranteId={restauranteId} 
                        />;
            case 'BuscarAgricultores':
                return <BuscarAgricultoresPage 
                            onNavigate={handleNavigateSimple}
                        />;
            case 'ProdutosAgricultor':
                return <ProdutosAgricultorPage 
                            onNavigate={handleNavigateSimple}
                        />;
            case 'Home':
            default:
                return <Home onNavigate={handleNavigateSimple} />;
        }
    };

    const isFullscreenPage = currentPage === 'Login' || currentPage === 'Cadastro';

    return (
        <div className="App">
            {!isFullscreenPage && (
                <header className="App-header">
                    <nav className="Nav-bar">
                        <button className="logo-button" onClick={() => {
                            if (isLoggedIn) {
                                setCurrentPage(userType === 'RESTAURANTE' ? 'Estoque' : 'ProdutosAgricultor');
                            } else {
                                setCurrentPage('Home');
                            }
                        }}>
                            M<span style={{fontFamily: 'Sedgwick Ave, cursive', textTransform: 'lowercase', fontSize: '20px'}}>u</span>DA
                        </button>
                        {!isLoggedIn ? ( 
                            <>
                                <button onClick={() => setCurrentPage('Login')}>Login</button>
                                <button onClick={() => setCurrentPage('Cadastro')}>Cadastrar</button>
                            </>
                        ) : (
                            <div className="nav-menu-logged">
                                {userType === 'RESTAURANTE' ? (
                                    <>
                                        <button className="nav-menu-item" onClick={() => setCurrentPage('Perfil')}>
                                            Meu Perfil
                                        </button>
                                        <button className="nav-menu-item" onClick={() => setCurrentPage('Estoque')}>
                                            Meu Estoque
                                        </button>
                                        <button className="nav-menu-item" onClick={() => setCurrentPage('BuscarAgricultores')}>
                                            Buscar Produtores
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <button className="nav-menu-item" onClick={() => setCurrentPage('Perfil')}>
                                            Meu Perfil
                                        </button>
                                        <button className="nav-menu-item" onClick={() => setCurrentPage('ProdutosAgricultor')}>
                                            Meus Produtos
                                        </button>
                                    </>
                                )}
                                <button className="nav-menu-item logout" onClick={handleLogout}>
                                    Sair
                                </button>
                            </div>
                        )}
                    </nav>
                </header>
            )}
            <main className={`App-main ${isFullscreenPage ? 'fullscreen' : ''}`}>
                {renderPage()} 
            </main>
            {!isFullscreenPage && (
                <footer className="App-footer">
                    <p>&copy; 2025 Muda - Conectando Restaurantes e Agricultores</p>
                </footer>
            )}
        </div>
    );
};

export default App;